// src/JobTable.js
import React, { useEffect } from 'react';
import {
  Container, Row, Col, Card, Form, Button
} from 'react-bootstrap';
import DataTable        from 'react-data-table-component';
import Select           from 'react-select';
import useSessionState  from './hooks/useSessionState';
import { useAuth }      from './contexts/AuthContext';
import './JobTable.css';

/* ------------------------------------------------------------------ */
/*  yardımcılar                                                        */
/* ------------------------------------------------------------------ */
const makeOpts = (arr, fn) =>
  [...new Set(arr.map(fn))].filter(Boolean).map(v => ({ value: v, label: v }));

/* ------------------------------------------------------------------ */
/*  Bileşen                                                            */
/* ------------------------------------------------------------------ */
export default function JobTable() {
  /* ---------- auth ---------- */
  const { user: currentUser } = useAuth();          // null → misafir
  const isGuest = !currentUser;

  /* ---------- kalıcı state’ler ---------- */
  const [jobs,         setJobs]         = useSessionState('jobsList',       []);
  const [highlighted,  setHighlighted]  = useSessionState('highlightedJobs',[]);
  const [titleF,       setTitleF]       = useSessionState('titleFilter',    '');
  const [stateF,       setStateF]       = useSessionState('stateFilter',    []);
  const [cityF,        setCityF]        = useSessionState('cityFilter',     []);
  const [bankF,        setBankF]        = useSessionState('bankFilter',     []);

  /* ---------- fetch once ---------- */
  useEffect(() => {
    if (jobs.length) return;                         // cache
    fetch('/api/jobs')
      .then(r => r.json())
      .then(data => {
        setJobs(data);
        setHighlighted(
          data.slice().sort(()=>0.5-Math.random()).slice(0,8)
        );
      })
      .catch(console.error);
  }, [jobs]);

  /* ---------- dropdown / datalist kaynakları ---------- */
  const stateOpts = makeOpts(jobs, j => j._source.state);
  const cityOpts  = makeOpts(jobs, j => j._source.city);
  const bankOpts  = makeOpts(jobs, j => j._source.Name);
  const titleList = [...new Set(jobs.map(j => j._source.title))];

  /* ---------- filtreleme ---------- */
  const filtered = jobs.filter(j => {
    const { title, state, city, Name } = j._source;
    if (titleF && !title.toLowerCase().includes(titleF.toLowerCase())) return false;
    if (stateF.length && !stateF.find(s => s.value === state))         return false;
    if (cityF.length  && !cityF.find(c => c.value === city))           return false;
    if (bankF.length  && !bankF.find(b => b.value === Name))           return false;
    return true;
  });

  /* ---------- misafir görünümü → 50 kayıt ile sınırla ---------- */
  const visibleRows = isGuest ? filtered.slice(0,50) : filtered;

  /* ---------- kolonlar ---------- */
  const columns = [
    {
      name: 'Title',
      selector: r => r._source.title,
      sortable: true,
      cell: r => (
        <a href={r._source.url} target="_blank" rel="noopener noreferrer">
          {r._source.title}
        </a>
      )
    },
    { name: 'State', selector: r => r._source.state, sortable: true },
    { name: 'City',  selector: r => r._source.city,  sortable: true },
    {
      name: 'Bank',
      selector: r => r._source.Name,
      sortable: true,
      cell: r => (
        <a
          href={`https://${r._source.Website}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {r._source.Name}
        </a>
      )
    },
    {
      name: 'Post Date',
      selector: r => r._source.post_date || r._source.scrapedate,
      sortable: true
    }
  ];

  /* ---------- JSX ---------- */
  return (
    <Container className="job-container">
      {/* Highlighted 8 cards */}
      <Row className="g-4 mb-4">
        {highlighted.map(job => (
          <Col md={6} lg={3} key={job._id}>
            <a
              href={job._source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="job-card-wrapper"
            >
              <Card className="job-card h-100 shadow-sm">
                <Card.Body>
                  <Card.Title>{job._source.title}</Card.Title>
                  <Card.Text>
                    <strong>Bank:</strong> {job._source.Name}<br/>
                    <strong>Location:</strong> {job._source.city}, {job._source.state}
                  </Card.Text>
                </Card.Body>
              </Card>
            </a>
          </Col>
        ))}
      </Row>

      {/* Filters */}
      <Row className="g-3 filters mb-4">
        <Col md={3}>
          <Form.Control
            type="text" list="titles" placeholder="Search Title..."
            value={titleF} onChange={e=>setTitleF(e.target.value)}
          />
          <datalist id="titles">
            {titleList.map((t,i)=><option key={i} value={t}/>)}
          </datalist>
        </Col>
        <Col md={3}>
          <Select isMulti options={stateOpts} placeholder="State"
                  value={stateF} onChange={setStateF}/>
        </Col>
        <Col md={3}>
          <Select isMulti options={cityOpts}  placeholder="City"
                  value={cityF}  onChange={setCityF}/>
        </Col>
        <Col md={3}>
          <Select isMulti options={bankOpts}  placeholder="Bank"
                  value={bankF}  onChange={setBankF}/>
        </Col>
      </Row>

      {/* Guest notice */}
      {isGuest && (
        <div className="guest-overlay text-center mt-3">
          <p className="mb-3">
            Showing <strong>{visibleRows.length}</strong> of&nbsp;
            <strong>{filtered.length}</strong> job listings.<br/>
            Sign up or log in to see every posting.
          </p>
          <Button variant="primary" className="me-2" href="/signup">
            Sign Up
          </Button>
          <Button variant="outline-secondary" href="/login">
            Log In
          </Button>
        </div>
      )}
      {/* Data-table */}
      <DataTable
        className="data-table-extended"
        title="Job Listings"
        columns={columns}
        data={visibleRows}
        pagination
        responsive
      />

     
    </Container>
  );
}
